// 批次取藥 component

<template lang="pug">
  div
    div.upper-subpanel.row
      progressBar
      div.upper-subpanel--without-progressbar
        Loader(v-if="stage === 'loading'")
        div.med-schedule-wrapper(v-show="stage === 'selectDrug' && schedules.length > 0 && viewMethod === 'list'")
          div.med-select(style="height: 100%")
            div.med-button(
              :class="{ 'selected-med-button': item.selected, 'unselectable': item.amountInSystem === 0 }"
              v-for="item, index in schedules"
              @click="selectMed(index)") 
              div#med_desc
                h6 {{ item.medication.code }} - {{ item.medication.CGMH_number }}
                h6 {{ item.medication.generic_name }}
              div
                div#amount
                  span 取藥數量
                  span {{ item.amount }}
                div#date
                  span 取藥日期
                  span {{ item.fetch_date }}
                div#patient
                  span 病歷號
                  span {{ item.patient.med_record_number }}
                //- div#fetched
                //-   span 取藥狀況
                //-   span(:class="{ 'color-green': item.fetched }") {{item.fetched | zhFetched }}
                div#remain_amount 
                  span 系統存量
                  span {{ item.amountInSystem }}
        div.drug-list-wrapper(v-show="stage === 'selectDrug' && schedules.length > 0 && viewMethod === 'drugCategory'")
          div.drug-list-item(v-for="drug in schedulesByDrug" @click="selectScheduleByDrug(drug)" :class="{ 'selected-med-button': drug.selected, 'unselectable': drug.amountInSystem === 0 }")
            div.fixed-icon
              font-awesome-layers(class="fa-lg fa-fw")
                font-awesome-icon(:icon="faCircle" size="lg" color="red")
                font-awesome-icon(:icon="faPills" transform="shrink-6 right-2" color="white")
            div
              p {{ drug.medication.CGMH_number }} - {{ drug.medication.code }}
              p 
                small {{drug.medication.generic_name}}
            div
              p 
                small 藥物庫存量: {{ drug.amountInSystem }} / 藥單張數: {{ drug.listSet.length }}

        div.with-child-centered(v-if="stage === 'selectDrug' && schedules.length === 0")
          h3 無取藥資料
        MultiFlow(
          v-if="stage === 'startFlow'"
          :multiProgress="multiProgress"
          :confirmProgress="confirmProgress"
          :actionProgress="actionProgress"
          :schedules="schedules"
          :summarySelectedMed="summarySelectedMed"
          v-on:setAllConfirmData="getAllConfirmData"
        )
    BottomButtons
      action-button(title="回主畫面" slot="button-1" @click.native="cancel" :clickable="currentApp.cancel")
      action-button(title="列表模式" slot="button-4" @click.native="viewMethod = 'list'" v-if="stage === 'selectDrug'")
      action-button(title="藥物模式" slot="button-3" @click.native="viewMethod = 'drugCategory'" v-if="stage === 'selectDrug'")
      action-button(title="選擇全部" slot="button-7" @click.native="selectAll" v-if="stage === 'selectDrug'")
      action-button(title="取消全選" slot="button-7" @click.native="deselectAll" v-if="stage === 'selectDrug'")
      action-button(title="開始取藥" slot="button-9" @click.native="startFlow" v-if="stage === 'selectDrug'" :clickable="Object.values(summarySelectedMed).length > 0")
</template>

<script>
import _ from 'lodash';
import { faPills, faCircle } from '@fortawesome/free-solid-svg-icons';
import MultiFlow from './FetchDrugScheduleFlow/MultiFlow';
import progressBar from './flowComp/ProgressBar';
import Loader from './common/Loader';
import BottomButtons from './common/BottomButtons';
import AppBase from './ComponentBase/AppBase';


export default {
  name: 'FetchDrugSchedule',
  extends: AppBase,
  components: {
    progressBar,
    MultiFlow,
    Loader,
    BottomButtons,
  },
  data() {
    return {
      summarySelectedMed: {},
      schedules: [],
      viewMethod: '',
      faPills,
      faCircle,
    };
  },
  computed: {
    schedulesByDrug() {
      const byDrug = {};
      this.schedules.forEach((item) => {
        if (byDrug[item.medication.id] === undefined) {
          byDrug[item.medication.id] = {};
          byDrug[item.medication.id].medication = item.medication;
          byDrug[item.medication.id].listSet = [];
        }
        byDrug[item.medication.id].listSet.push(item);
      });
      Object.values(byDrug).forEach((item) => {
        item.selected = false;
        item.amountInSystem = item.listSet[0].amountInSystem;
        for (let i = 0; i < item.listSet.length; i += 1) {
          const theList = item.listSet[i];
          if (theList.selected) {
            item.selected = true;
            break;
          }
        }
      });
      return Object.values(byDrug);
    },
  },
  created() {
    this.stage = 'selectDrug';
    this.viewMethod = 'drugCategory';
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.actionProgress = this.setupActionWrapProgress();
  },
  mounted() {
    this.schedules = [];
    this.getScheduleData('/api/fetch-schedule/');
  },
  methods: {
    setupProgress() {
      const p = [];
      p.push({ en: 'selectDrug', zh: '選擇藥物' });
      //20190422 add 覆核動作
      if (this.$store.state.user.user.task_privilege.fetch_drug === false) {
        p.push({ en: 'rxCheck', zh: '覆核動作' });
      }
      if (this.$store.state.generalSetting.check_amount_first) {
        p.push({ en: 'confirmAmount', zh: '確認數量' });
      }
      p.push({ en: 'action', zh: '進行取藥' });
      return p;
    },
    setupMultiProgress() {
      return [
        'confirm',
        'finish',
      ];
    },
    setupConfirmProgress() {
      //20190422 modified
      /*
      return [
        'actionWrap',
      ];
      */
      const prog = [];
      if (this.$store.state.user.user.task_privilege.fetch_drug === false) {
        prog.push('rxCheck');
      }
      prog.push('actionWrap');
      return prog;
    },
    setupActionWrapProgress() {
      const prog = [];
      if (this.$store.state.generalSetting.check_amount_first) {
        prog.push('confirmAmount');
      }
      prog.push('action');
      prog.push('next');
      return prog;
    },
    getScheduleData(url) {
      this.stage = 'loading';
      return this.instance.get(url)
      .then((res) => {
        res.data.results.forEach((item) => {
          item.selected = false;
          item.drugInDevice = _.filter(this.$store.getters.drugInDeviceList, (drugStorage) => {
            return drugStorage.medication.id === item.medication.id && drugStorage.stock > 0;
          });
          item.amountInSystem = 0;
          item.drugInDevice.forEach((d) => {
            item.amountInSystem += d.stock;
          });
          this.schedules.push(item);
        });
        if (res.data.next_page_url !== null) {
          const url = res.data.next_page_url.substr(res.data.next_page_url.indexOf('/', 7));
          this.getScheduleData(url);
        }
        this.stage = 'selectDrug';
      });
    },
    selectMed(index, selected) {
      const schedule = this.schedules[index];
      if (selected !== undefined) {
        schedule.selected = selected;
      } else {
        schedule.selected = !schedule.selected;
      }
      // add if selected
      if (schedule.selected) {
        if (this.summarySelectedMed[schedule.medication.id] === undefined) {
          this.summarySelectedMed[schedule.medication.id] = {
            med: schedule.medication, drugStorage: schedule.drugInDevice, amount: 0, select: schedule.selected, schedules: [],
          };
        }
        this.summarySelectedMed[schedule.medication.id].amount += schedule.amount;
        this.summarySelectedMed[schedule.medication.id].schedules.push(schedule.id);
      } else {
        this.summarySelectedMed[schedule.medication.id].amount -= schedule.amount;
        const removeScheduleInd = this.summarySelectedMed[schedule.medication.id].schedules.findIndex((element) => { return element === schedule.id; });
        if (removeScheduleInd) {
          this.summarySelectedMed[schedule.medication.id].schedules.splice(removeScheduleInd, 1);
        }
        // delete the item if amount is zero.
        if (this.summarySelectedMed[schedule.medication.id].amount === 0) {
          delete this.summarySelectedMed[schedule.medication.id];
        }
      }
    },
    cancel() {
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_FETCH' });
      this.$router.push({ name: 'Main' });
    },
    startFlow() {
      Object.values(this.summarySelectedMed).forEach((item) => {
        this.$store.dispatch('setDrugListForFetch', item);
      });
      this.stage = 'startFlow';
    },
    async getAllConfirmData() {
      this.stage = 'loading';
      this.summarySelectedMed = {}; // reset variable
      this.schedules = [];
      // refetch data
      this.$store.dispatch('resetAll');
      await this.$store.dispatch('getDrugInDevices');
      await this.getScheduleData('/api/fetch-schedule/');
      this.stage = 'selectDrug';
      this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
    },
    selectAll() {
      this.summarySelectedMed = {};
      for (let i = 0; i < this.schedules.length; i += 1) {
        if (this.schedules[i].amountInSystem > 0) this.selectMed(i, true);
      }
    },
    deselectAll() {
      for (let i = 0; i < this.schedules.length; i += 1) {
        if (this.schedules[i].amountInSystem > 0) this.selectMed(i, false);
      }
    },
    selectScheduleByDrug(drugItem) {
      drugItem.listSet.forEach((item) => {
        const index = this.schedules.findIndex((o) => { return o.id === item.id; });
        this.selectMed(index, !drugItem.selected);
      });
    },
  },
  filters: {
    zhFetched(val) {
      if (val) return '已取藥';
      return '未取藥';
    },
  },
};
</script>

<style lang="sass">
.med-schedule-wrapper
  height: 100%
  display: flex
  flex-direction: column

.med-select
  height: calc(100% - 40px)
  overflow-y: scroll
  &::-webkit-scrollbar-track
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  &::-webkit-scrollbar
    width: 12px;
    background-color: #F5F5F5;  
  &::-webkit-scrollbar-thumb
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #555;


.med-button
  margin: 5px 5px
  box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);
  // border: 1px solid transparent
  background-color: #f4f4f4
  border-color: #dbdbdb
  display: flex;
  justify-content: space-between;
  transition: all ease 0.3s
  padding: 5px 10px
  #med_desc
    h6
      margin: 0.5rem
      &:nth-child(2)
        font-size: 12px
  #remain_amount, #patient, #date, #fetched, #amount
    border-left: 1px solid rgba(0,0,0,0.2)
    padding: 5px 15px
    display: inline-flex
    flex-direction: column
    justify-content: center
    align-items: center
    span
      font-size: 20px
      &:first-child
        font-size: 12px
  #patient
    width: 120px
  
      
.unselectable
  pointer-events: none;
  box-shadow: none;
  border-style: unset
  color: rgba(0,0,0,0.3)
  .amount-button
    background-color: rgba(0,0,0,0.3) !important
  #remain_amount
    color: red

.selected-med-button
  background: cadetblue
  color: white
  #remain_amount
    border-color: white

.drug-list-wrapper
  height: 100%
  overflow-y: auto
  &::-webkit-scrollbar-track
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  &::-webkit-scrollbar
    width: 12px;
    background-color: #F5F5F5;  
  &::-webkit-scrollbar-thumb
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #555;

.drug-list-item
  transition: all ease 0.3s;
  box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between
  position: relative
  width: 225px
  height: 110px
  margin: 10px
  padding: 10px
  p
    font-size: 14px
    margin: 0

.fixed-icon
  position: absolute
  right: 6px
  top: 8px

</style>



// WEBPACK FOOTER //
// FetchDrugSchedule.vue?480ba6ab